/**
 * LightGallery - Shared Image Gallery Configuration
 * Configuration commune pour les galeries d'images
 */

import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

/**
 * Initialize LightGallery for static thumbnails
 */
export function initStaticThumbnails() {
    const galleryElement = document.getElementById('static-thumbnails');
    if (galleryElement) {
        lightGallery(galleryElement, {
            plugins: [lgVideo, lgZoom],
            thumbnail: false,
            zoom: true,
            mode: 'lg-slide',
            selector: 'a:not(.listingLink)'
        });
    }
}

/**
 * Initialize LightGallery with custom configuration
 * @param {string} selector - CSS selector for gallery container
 * @param {object} options - LightGallery options
 */
export function initCustomGallery(selector, options = {}) {
    const galleryElement = document.querySelector(selector);
    if (galleryElement) {
        const defaultOptions = {
            plugins: [lgVideo, lgThumbnail, lgZoom],
            thumbnail: true,
            zoom: true,
            mode: 'lg-slide'
        };
        
        lightGallery(galleryElement, { ...defaultOptions, ...options });
    }
}

// Auto-initialize on DOM load
document.addEventListener("DOMContentLoaded", function() {
    initStaticThumbnails();
});
